import { useQuery } from "@tanstack/react-query";
import type { userSearchAPIInterface } from "@dealer-center/ddc-api-user-interface";

export interface userSearchFetchInterface {
  name: string;
}
const queryKeyBase = "ddc-pages-user-search";

export function useUserSearchGet(userName?: string) {
  return useQuery({
    queryKey: [queryKeyBase, userName],
    queryFn: () => fetchUserSearchGet(userName?.trim() || ""),
    enabled: !!userName && userName.trim().length > 0
  });
}

const fetchUserSearchGet = (
  userName: string
): Promise<userSearchAPIInterface> => {
  return fetch(
    "/landing/nxlambda/userSearch/" + encodeURIComponent(userName.trim())
  ).then(res => {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error(res.statusText);
    }
  });
};
